import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterTransactionListContext } from '../../transaction.context';
import { TransactionListFilterFormStep1Controller } from '../transaction-list-filter-form-step-1/transaction-list-filter-form-step-1.controller';

export interface TransactionListFilterFormControllerProps {
  onError: SubmitErrorHandler<GatewayGetTransactionsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GatewayGetTransactionsPaginatedModel>;
  onCancel: () => void;
}

export const TransactionListFilterFormController = (
  props: TransactionListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterTransactionListContext();

  return (
    <MultiStepFormProvider<GatewayGetTransactionsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: [
            'createdAfter',
            'createdBefore',
            'locationId',
            'chargePointId',
          ],
          component: <TransactionListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
